var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-page',{attrs:{"centralise":"yes"}},[_c('div',{staticClass:"fail"},[_c('h1',[_vm._v("Something broke!")]),_c('p',[_vm._v("Sorry, there was an error that caused the app to crash.")]),_c('core-button',{attrs:{"theme":"blue"},nativeOn:{"click":function($event){return _vm.onClick.apply(null, arguments)}}},[_vm._v("Go to home")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }